import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { DashboardComponent } from './main/dashboard/dashboard.component';
import { ORGANIZATION_ROUTES } from './organization/organization.routes';
import { PERSON_ROUTES } from './person/person.routes';
import { OrganizationComponent } from './organization/organization.component';
import { PersonComponent } from './person/person.component';
import { AdministrationComponent } from './administration/administration.component';
import { ADMINISTRATION_ROUTES } from './administration/administration.routes';
import { UserRolesComponent } from './user-roles/user-roles.component';
import { NotificationsComponent } from './notifications/notifications.component';
import { AuthenticatedGuardService } from './shared/services/security/authenticated-guard.service';
import { RoleGuardService } from './shared/services/security/role-guard.service';
import { VerifyContactMailComponent } from './main/others/verify-contact-mail/verify-contact-mail.component';
import { DataPortalComponent } from './data-portal/data-portal.component';
import { DATA_PORTAL_ROUTES } from './data-portal/data-portal.routes';
import { TrackChangesComponent } from './track-changes/track-changes.component';
import { UserCountComponent } from './user-count/user-count.component';
import { USER_COUNT_ROUTES } from './user-count/user-count.routes';

const routes: Routes = [
  { path: '', redirectTo: '/contacts', pathMatch: 'full' },
  {
    path: 'contacts', component: DashboardComponent
  },
  {
    path: 'contact/mail/verification/:token', component: VerifyContactMailComponent
  },
  {
    path: 'user-roles', component: UserRolesComponent,
    canActivate: [AuthenticatedGuardService, RoleGuardService],
    data: {
      expectedRole: 'WSD_USER_ROLES_READ'
    }
  },
  {
    path: 'notifications', component: NotificationsComponent,
    canActivate: [AuthenticatedGuardService, RoleGuardService],
    data: {
      expectedRole: 'WSD_NOTIFICATIONS_READ'
    },
  },
  {
    path: 'organizations', component: OrganizationComponent,
    children: ORGANIZATION_ROUTES
  },
  {
    path: 'persons', component: PersonComponent,
    canActivate: [AuthenticatedGuardService],
    children: PERSON_ROUTES
  },
  {
    path: 'reports', component: UserCountComponent,
    canActivate: [AuthenticatedGuardService, RoleGuardService],
    data: {
      expectedRole: 'WSD_IDM_USER_REPORT_READ'
    },
    children: USER_COUNT_ROUTES
  },
  {
    path: 'administration',
    component: AdministrationComponent,
    canActivate: [AuthenticatedGuardService, RoleGuardService],
    data: {
      expectedRole: 'WSD_CLASSIFICATIONS_READ'
    },
    children: ADMINISTRATION_ROUTES
  },
  {
    path: 'data',
    component: DataPortalComponent,
    canActivate: [AuthenticatedGuardService],
    children: DATA_PORTAL_ROUTES
  },
  {
    path: 'data/:id',
    component: DataPortalComponent,
    canActivate: [AuthenticatedGuardService],
    children: DATA_PORTAL_ROUTES
  },
  {
    path: 'track-changes',
    component: TrackChangesComponent,
    canActivate: [AuthenticatedGuardService],
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {})],
  exports: [RouterModule]
})
export class AppRoutingModule {
}
